<template>
<v-card width="100%">
    <v-tabs
      v-model="tab"
      class="yellowPlexi"
    >
      <v-tab value="energy" @click="clickTabEnergy()">Energy Management</v-tab>
      <v-tab value="soc" disabled>State of Charge</v-tab>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item value="energy">
          <tab-plant-details-plot-energy
            :data="dataPlotEnergyVpp"
            :loading-plot="loadingPlotVpp"
          >
          </tab-plant-details-plot-energy>
        </v-window-item>
        <v-window-item value="soc">
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
</template>

<script>
import TabPlantDetailsPlotEnergy from '../TabPlantEnergyPlot/TabPlantDetailsPlotEnergy.vue'
export default {
  name: 'TabPlantDetailsPlot',

  components: {
    TabPlantDetailsPlotEnergy
  },
  props: {
    dataPlotEnergyVpp: {
      type: Object,
      default: () => ({})
    },
    loadingPlotVpp: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tab: null
  }),

  computed: {

  },

  watch: {
  },
  mounted () {

  },
  methods: {
    clickTabEnergy () {

    }
  }
}
</script>

<style scoped>
.v-tab.v-tab {
    height: 25px;
}
</style>
